import { List_Organizations_Settings } from "@/graphql/queries.js";
import { generateClient } from "aws-amplify/api";
const client = generateClient();
export const GetAllEscalationNotifications = {
  data() {
    return {
      overlay: false,
      noDataText: "",
      GetAllEscalationNotificationList: [],
    };
  },
  methods: {
    async GetAllEscalationNotificationMethod(setting_status) {
      try {
        this.overlay = true;
        let result = await client.graphql({
          query: List_Organizations_Settings,
          variables: {
            input: {
              organization_id:
                this.$store.getters.get_current_user_details.organization_id,
              setting_type: "ESCALATION_NOTIFICATION",
              setting_status: setting_status,
            },
          },
        });

        this.GetAllEscalationNotificationList = JSON.parse(
          result.data.List_Organizations_Settings
        ).data.items;
        this.overlay = false;
      } catch (error) {
        this.overlay = false;
        this.GetAllEscalationNotificationList = [];
        this.noDataText = error.errors[0].message;
      }
    },
  },
};
